import { cn } from '@/utils/cn';

const variants = {
  success: 'bg-success-tint text-success-ink border-success/20',
  warning: 'bg-warning-tint text-warning-ink border-warning/20',
  archived: 'bg-archived-tint text-archived border-border',
  danger: 'bg-error-tint text-error-ink border-error/20',
  neutral: 'bg-surface-muted text-foreground-muted border-border',
  brand: 'bg-brand-subtle text-brand-deep border-brand/20',
} as const;

export type BadgeVariant = keyof typeof variants;

/** Badge variant for an Amazon Ads entity state (ENABLED / PAUSED / ARCHIVED). */
export function entityStateBadgeVariant(state: string): BadgeVariant {
  const normalized = state.toUpperCase();
  if (normalized === 'ENABLED') return 'success';
  if (normalized === 'PAUSED') return 'warning';
  if (normalized === 'ARCHIVED') return 'archived';
  return 'neutral';
}

export function Badge({
  variant = 'neutral',
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { variant?: BadgeVariant }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-pill px-2 py-0.5 text-label-md font-semibold uppercase tracking-[0.08em] border',
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
